import { ResourceOptions } from 'react-admin';
import { MdOutlineAccountBalanceWallet } from 'react-icons/md';

import { Resources } from '../../resource';

export { default as list } from './List';
// The §14.4 vault detail (XBIT-4239) at `/vault/vaults/:id`: react-admin mounts `edit` at `:id`; the page reads the id
// with useParams and edits nothing (the same precedent as Investors).
export { default as edit } from './Detail';
export { VAULTS_PERMISSION_RESOURCE } from './constants';

export const name = Resources.vaultVaults;
export const icon = MdOutlineAccountBalanceWallet;
export const options: ResourceOptions = {
  label: 'module.vaults.title',
};
